var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyseInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5157 22.2149L19.2915 20.9909L20.9919 19.2949L22.216 20.519L22.4841 20.2469C22.6402 20.0909 22.8921 20.0909 23.0482 20.2469L27.4208 24.619C28.1929 25.391 28.1929 26.6471 27.4208 27.4191C27.0487 27.7952 26.5526 27.9992 26.0205 27.9992C25.4924 27.9992 24.9963 27.7952 24.6202 27.4191L20.2476 23.047C20.0915 22.891 20.0915 22.639 20.2476 22.483L20.5157 22.2149Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8222 10.8225L10.8221 10.8225C9.64587 11.9987 9.00019 13.5583 9 15.2225L10.8222 10.8225ZM10.8222 10.8225C11.9986 9.64606 13.558 9 15.2223 9C16.886 9 18.4454 9.64603 19.6219 10.8225C20.7984 11.9989 21.4444 13.5586 21.4444 15.2225C21.4444 16.8861 20.7984 18.4455 19.6219 19.6219L19.6217 19.6221M10.8222 10.8225L19.6217 19.6221M19.6217 19.6221C18.4454 20.7989 16.8862 21.4444 15.2223 21.4444C13.5578 21.4444 11.9987 20.7989 10.8223 19.622L10.8222 19.6219M19.6217 19.6221L10.8222 19.6219M10.8222 19.6219C9.64577 18.4456 9.00003 16.8863 9 15.2226L10.8222 19.6219Z",
    stroke: "#B3B3B3",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyseInactive);
export default __webpack_public_path__ + "static/media/analyse-inactive.d7394080104c753d590fef658d3c77d1.svg";
export { ForwardRef as ReactComponent };